import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Faq } from '../../../../models/Faq';
import {
  getAllFaqs,
  addFaq,
  updateFaq,
  deleteFaq,
} from '../../../../state/faq/faq.actions';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { selectAllFaqs } from '../../../../state/faq/faq.selector';
import { PageHeaderComponent } from '../../../page-header/page-header.component';

@Component({
  selector: 'app-manage-faqs',
  standalone: true,
  templateUrl: './manage-faqs.component.html',
  styleUrl: './manage-faqs.component.css',
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    PageHeaderComponent
  ],
})
export class ManageFaqsComponent implements OnInit {
  faqs$: Observable<Faq[]>;
  displayedColumns: string[] = ['question', 'answer', 'actions'];
  faqForm: FormGroup;
  editingFaq: Faq | null = null;

  constructor(private store: Store, private fb: FormBuilder) {
    this.faqs$ = this.store.select(selectAllFaqs);
    this.faqForm = this.fb.group({
      id: [null],
      question: [''],
      answer: [''],
    });
  }

  ngOnInit(): void {
    this.store.dispatch(getAllFaqs());
  }

  startEdit(faq: Faq) {
    this.editingFaq = faq;
    this.faqForm.patchValue(faq);
  }

  cancelEdit() {
    this.editingFaq = null;
    this.faqForm.reset();
  }

  saveFaq() {
    let faq: Faq = this.faqForm.value;
    // Ensure id is 0 for new FAQ (backend expects int, not null/undefined)
    if (!faq.id) {
      faq = { ...faq, id: 0 };
    }
    if (faq.id && faq.id !== 0) {
      this.store.dispatch(updateFaq({ faq }));
    } else {
      this.store.dispatch(addFaq({ faq }));
    }
    this.cancelEdit();
  }

  deleteFaq(id: number) {
    this.store.dispatch(deleteFaq({ id }));
    if (this.editingFaq?.id === id) {
      this.cancelEdit();
    }
  }

  back(): void {
    window.history.back();
  }
}
